import { slug } from '@magalu/mixer-utils';
var sort = function sort() {
  var _args$data, _args$data$search, _args$data$search$ter, _data$sort, _data$sort2;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var termSearched = (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : (_args$data$search = _args$data.search) == null ? void 0 : (_args$data$search$ter = _args$data$search.term) == null ? void 0 : _args$data$search$ter.raw) || '';
  var optionSort = (data == null ? void 0 : (_data$sort = data.sort) == null ? void 0 : _data$sort.label) || '';
  return (data == null ? void 0 : (_data$sort2 = data.sort) == null ? void 0 : _data$sort2.label) && {
    content_id: "ordenacao:".concat(slug(optionSort)),
    content_type: 'busca:filtro',
    event: 'select_content',
    raw: termSearched
  };
};
export default sort;